// =============================================================================
// notificationsCloche.js — la cloche de l'en-tête (30/09/2026). SEULE partie
// du centre de notifications dans le bundle principal : un crochet qui charge
// la lecture (src/notificationsLecture.js) à l'ouverture de la session et
// garde son dernier état. Règles : src/notificationsRegles.js ; panneau :
// src/CentreNotifications.js ; textes : src/notificationsGabarits.js.
// =============================================================================
import { useEffect, useRef, useState } from "react";

const RIEN = () => Promise.resolve();
const VIDE = Object.freeze({ notifs: [], files: {}, pret: false, erreur: false, annonce: "", annonceN: 0, aTraiter: 0, nouvelles: 0,
  libelle: "Notifications", marquerLues: RIEN, toutMarquerLu: RIEN, marquerTraitees: RIEN, rouvrir: RIEN });

/** @param moi session RÉELLE ; @param favoris projets suivis (null : on ne sait pas). */
export function useCloche(moi, isAdmin, favoris) {
  const [etat, setEtat] = useState(VIDE);
  const abo = useRef(null);
  const favorisRef = useRef(favoris);
  favorisRef.current = favoris;
  const id = moi && moi.id;
  const poles = moi && Array.isArray(moi.polesInteret) ? moi.polesInteret.join("|") : "";
  const email = (moi && moi.email) || "";
  useEffect(() => {
    if (!id) { setEtat(VIDE); return undefined; }
    let fini = false;
    import("./notificationsLecture").then((m) => {
      if (!fini) abo.current = m.abonner(moi, isAdmin, (e) => { if (!fini) setEtat(e); }, favorisRef.current);
    }).catch(() => { if (!fini) setEtat({ ...VIDE, pret: true, erreur: true }); });
    return () => { fini = true; if (abo.current) abo.current.arreter(); abo.current = null; };
  }, [id, isAdmin, poles, email]); // eslint-disable-line react-hooks/exhaustive-deps
  const cleFavoris = Array.isArray(favoris) ? favoris.join("|") : null;
  useEffect(() => { if (abo.current) abo.current.favoris(favorisRef.current); }, [cleFavoris]);
  return etat;
}
